import { render } from "./EditLocationComponent.vue?vue&type=template&id=6c8ed933&scoped=true"
import script from "./EditLocationComponent.vue?vue&type=script&lang=js"
export * from "./EditLocationComponent.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-6c8ed933"

export default script